import React from 'react';

import {Edit} from 'react-admin';

import ChallengeForm from "./ChallengeForm";

const ChallengeEdit = (props) => (
    <Edit {...props}  mutationMode="pessimistic"><ChallengeForm/></Edit>
);

export default ChallengeEdit;
